module.exports = __webpack_public_path__ + "static/img/ss06.bc5d372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/rickle/ss06.png
// module id = 0G7f
// module chunks = 0